import Vue from "vue";

Vue.filter("titleCase", function (value) {
    if (!value) return "";
    value = value
        .toLowerCase()
        .replace("-", " ")
        .split(" ");
    for (var i = 0; i < value.length; i++) {
        value[i] = value[i].charAt(0).toUpperCase() + value[i].slice(1);
    }
    return value.join(" ");
});
